module.exports = __webpack_public_path__ + "static/media/electro.0ba248f6.svg";